<template>
  <div class="card p-4">
    <div class="card-header">
      <h4 class="card-title">Konfirmasi Pembayaran</h4>
    </div>
    <div class="card-body">
      <div class="float-right">
        <a class="image-popup-no-margins" :href="confirmPayment.file" title="Bukti Pembayaran">
          <img :src="confirmPayment.file" class="img-fluid img-container" width="125px" alt="" />
        </a>
      </div>
      <p class="text-muted">
        Diunggah pada {{ confirmPayment.uploadedAt }}
      </p>
        <ModalPicture></ModalPicture>
      <a :href="confirmPayment.file" class="btn btn-primary btn-sm" target="_blank">Unduh</a>
    </div>
  </div>
</template>

<script>
import ModalPicture from '../modal/modalPicture.vue'
// import $ from 'jquery'
  export default {
  components: { ModalPicture },
    props: {
      confirmPayment: {},
    },
    methods: {
    }
  }
</script>

